<template>
    <div>
        <vue-bootstrap4-table :rows="webcasts" :columns="dt.columns" :config="dt.config" :classes="dt.classes">
            <template slot="sort-asc-icon">
                <i class="fas fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
                <i class="fas fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
                <i class="fas fa-sort text-gray-200"></i>
            </template>
            <template slot="action" slot-scope="props">
                <a v-if="editable == 1 && props.row.sent_at == null" class="btn btn-success btn-sm btn-icon-split" :href="'/webcast/'+props.row.hashid+'/edit'">
                    <span class="icon text-white-50">
                        <i class="fas fa-pen "></i>
                    </span>
                    <span class="text">Edit</span>
                </a>
                <button v-if="editable == 1 && props.row.sent_at == null" class="btn btn-danger btn-sm btn-icon-split" @click="confirm(props.row)">
                    <span class="icon text-white-50">
                        <i class="fas fa-trash "></i>
                    </span>
                    <span class="text">Delete</span>
                </button>
                <!--<a v-if="props.row.sent_at != null" :href="'/webcast/'+props.row.hashid +'/question'" class="btn btn-primary btn-sm btn-icon-split">
                    <span class="icon text-white-50">
                      <i class="fas fa-question"></i>
                    </span>
                    <span class="text">Questions</span>
                </a>-->
                <a v-if="props.row.sent_at != null" class="btn btn-primary btn-sm btn-icon-split" :href="'/webcast/'+props.row.hashid">
                    <span class="icon text-white-50">
                        <i class="fas fa-tachometer-alt "></i>
                    </span>
                    <span class="text">Dashboard</span>
                </a>
            </template>
        </vue-bootstrap4-table>
    </div>

</template>

<script>

    import VueBootstrap4Table from 'vue-bootstrap4-table'

	export default {
		name: "WebcastList",
        props: {
            editable: Boolean,
        },
        data() {
		    return {
                webcasts: [],
                dt: {
                    classes: {
                        table: {
                            "table-striped": true,
                        }
                    },
                    columns: [
                        {
                            label: "Name",
                            name: "name",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Total",
                            name: "viewers_count",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Accepted",
                            name: "accepted_viewers_count",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Watched",
                            name: "logged_in_viewers_count",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Webcast Start At",
                            name: "start_at",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                            initial_sort: true, // "false" by default
                            initial_sort_order: "desc", // "asc" by default
                        },
                        {
                            label: "Invitation Sent At",
                            name: "sent_at",
                            sort: true,
                            row_text_alignment:  "text-left",
                            column_text_alignment:  "text-left",
                        },
                        {
                            label: "Actions",
                            name: "hashid",
                            sort: false,
                            row_text_alignment:  "text-right",
                            column_text_alignment:  "text-right",
                            slot_name: "action"
                        },
                    ],
                    config: {
                        card_mode: false,
                        show_refresh_button: false,
                        show_reset_button: false,
                        per_page: 50,
                        per_page_options:  [50,  100,  200,  500],
                    }
                },
            }
        },
        components: {
            VueBootstrap4Table
        },
        mounted() {
            axios.get('/api/webcast').then((response) => {
                this.webcasts = response.data.webcasts

            }).catch((error) => {
                Swal.fire({
                    title: 'Error',
                    text: 'Unable to retrieve record',
                    icon: 'error',
                    confirmButtonText: 'Dismiss'
                }).then((result) => {
                });
            });
        },
        methods: {
		    confirm(row) {
                Swal.fire({
                    title: 'Are you sure?',
                    text: row.name+' will be removed permanently',
                    icon: 'question',
                    confirmButtonText: 'Yes, Delete It',
                    cancelButtonText: 'No, Go Back',
                    showCancelButton: true,
                    focusCancel: true,
                }).then((result) => {

                    if (result.value) {

                        axios.delete('/api/webcast/'+row.hashid).then((response) => {
                            /*_.remove(this.events, function(n){
                                return n.hashid == row.hashid
                            })*/
                            location.href='/webcast'
                        }).catch((error) => {
                            Swal.fire({
                                title: 'Error',
                                text: 'Unable to perform request',
                                icon: 'error',
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                location.href='/webcast'
                            })
                        })
                    }
                })
            }
        }
	}
</script>

<style scoped>

</style>
